module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-select"
  }, [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('select', {
    ref: "select",
    staticClass: "pretty-select",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    }
  }, _vm._l((_vm.normalizedOpts), function(opt) {
    return _c('option', {
      domProps: {
        "value": opt.val,
        "selected": opt.val === _vm.value
      }
    }, [_vm._v(_vm._s(opt.display))])
  }), 0), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 13 14",
      "height": "10px"
    }
  }, [_c('path', {
    attrs: {
      "d": "M.5 0v14l11-7-11-7z",
      "transform": "translate(13) rotate(90)"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8f6e6820!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrettySelect.vue
// module id = 687
// module chunks = 2